exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Typography__Typography__10WB1 {\n  font-size: 16px;\n  line-height: 1.38;\n  text-align: center;\n  white-space: pre;\n  word-break: keep-all;\n  color: #FFFFFF;\n  margin: 5px 0; }\n  .Typography__Typography__big__2xyC1 {\n    font-size: 40px;\n    line-height: 1.2; }\n  .Typography__Typography__xlarge__-URRX {\n    font-size: 28px;\n    line-height: 0.88; }\n  .Typography__Typography__large__kX6B- {\n    font-size: 24px;\n    line-height: 1.17; }\n  .Typography__Typography__small__2eEG1 {\n    font-size: 14px; }\n  .Typography__Typography__tiny__3Ah0B {\n    font-size: 12px; }\n  .Typography__Typography--thin__i2S1k {\n    font-family: 'sf-pro-display-thin', 'Noto Sans KR Thin';\n    font-weight: 200; }\n  .Typography__Typography--bold__1Tggw {\n    font-family: 'sf-pro-display-bold', 'Noto Sans KR Bold';\n    font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"Typography": "Typography__Typography__10WB1",
	"Typography__big": "Typography__Typography__big__2xyC1",
	"Typography__xlarge": "Typography__Typography__xlarge__-URRX",
	"Typography__large": "Typography__Typography__large__kX6B-",
	"Typography__small": "Typography__Typography__small__2eEG1",
	"Typography__tiny": "Typography__Typography__tiny__3Ah0B",
	"Typography--thin": "Typography__Typography--thin__i2S1k",
	"Typography--bold": "Typography__Typography--bold__1Tggw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/intro/components/Typography/Typography.scss
// module id = 548
// module chunks = 0